import gsap from 'gsap'

import {
  fadeRevealAnimation,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const editorialFullscreenRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const pretitle = selector('[data-motion-pretitle]')[0]
  const title = selector('[data-motion-title]')[0]
  const text = selector('[data-motion-text]')[0]
  const ctas = selector('[data-motion-ctas]')[0]

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: node,
      once: false,
      start: 'top bottom',
      end: 'top 5%',
      markers: false,
      invalidateOnRefresh: true,
      toggleActions: `play none none reverse`,
      scrub: true,
    },
    delay
  })

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = {
      timeline: gsap
        .timeline()
        .fromTo(
          media,
          { scale: 0.2 },
          { scale: 1, duration: 2, ease: 'power3.out' }
        ),
      revert: () => {
        return
      }
    }
    timeline.add(mediaAnimation.timeline, 0)
  }

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = linesRevealAnimation(pretitle, reverse)
    timeline.add(pretitleAnimation.timeline, 0.3)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0.3)
  }

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = linesRevealAnimation(text, reverse)
    timeline.add(textAnimation.timeline, 0.3)
  }

  let ctasAnimation: SharedAnimation
  if (ctas) {
    ctasAnimation = fadeRevealAnimation(ctas)
    timeline.add(ctasAnimation.timeline, 0.3)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    mediaAnimation?.revert()
    pretitleAnimation?.revert()
    titleAnimation?.revert()
    textAnimation?.revert()
    ctasAnimation?.revert()
  }
}
